import { AuthService } from "../../services/AuthService";
import { AuthStorage } from "../../storage/AuthStorage";
import { StorageConstants } from "../../storage/storageConstants";
import {
  SET_MOBILE_NO,
  SET_LOADING,
  SET_USERNAME,
  SET_OTP_LOGIN,
  SET_OTP_VERIFICATION,
  SET_USER_ID,
} from "./types";

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set mobile no
 */
export const setMobileNo = (data) => ({
  type: SET_MOBILE_NO,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set error
 */
export const setUsername = (data) => ({
  type: SET_USERNAME,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set otp login
 */
export const setOtpLogin = (data) => ({
  type: SET_OTP_LOGIN,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set user Id
 */
export const setUserId = (data) => ({
  type: SET_USER_ID,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set otp verification
 */
export const setOtpVerification = (data) => ({
  type: SET_OTP_VERIFICATION,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set otp verification
 */
export const otpLogin =
  (data, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuthService.login(data)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setUserId(res?.metadata?.OTP?.userId));
        await dispatch(setOtpLogin(res?.metadata?.OTP?.otp));
        await dispatch(setMobileNo(res?.metadata?.OTP?.mobileNo));
        successCallback(res?.metadata?.OTP?.otp);
      })
      .catch(async (err) => {
        console.log("Error in otp login: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set otp verification
 */
export const verifyLoginOtp =
  (data, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuthService.verifyOtp(data)
      .then(async (res) => {
        console.log("Result: ", res);
        const userData = res?.metadata?.loginToken;
        handleLoginResponse(userData);
        successCallback();
      })
      .catch(async (err) => {
        console.log("Error in otp login: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

const handleLoginResponse = async (data) => {
  console.log("Storage Item: ", data?.userId);
  await AuthStorage.setCookie(StorageConstants.USED_ID, data?.userId);
  await sessionStorage.setItem(StorageConstants.USED_ID, data?.userId);

  await localStorage.setItem(StorageConstants.LOGIN_TOKEN, data?.token);
  await localStorage.setItem(StorageConstants.USED_ID, data?.userId);
  await localStorage.setItem(StorageConstants.USER_NAME, data?.username);
  await localStorage.setItem(StorageConstants.MOBILE_NUMBER, data?.mobileNo);
  await localStorage.setItem(
    StorageConstants.LOGIN_TIME,
    `${new Date().valueOf()}`
  );
};

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to logout
 */
export const logout = (successCallback, errorCallback) => async (dispatch) => {
  await dispatch(setLoading(true));
  await AuthService.logout()
    .then(async (res) => {
      console.log("Result: ", res);
      handleLogoutResponse();
      successCallback();
    })
    .catch(async (err) => {
      console.log("Error in logout: ", err);
      errorCallback(err);
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

/**
 * @author Vikrant
 * @since 20-05-2024.
 * @description to upload profile pic
 */
export const uploadProfilePicture =
  (data, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuthService.uploadProfilePic(data)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in updating profile: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak
 * @since 20-05-2024.
 * @description to upload kyc pic
 * @deprecated It is not in use
 */
export const uploadKycPic =
  (data, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await AuthService.uploadProfilePic(data)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in updating profile: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

const handleLogoutResponse = async () => {
  await AuthStorage.deleteCookie(StorageConstants.USED_ID);
  await sessionStorage.clear();

  await localStorage.removeItem(StorageConstants.LOGIN_TOKEN);
  await localStorage.removeItem(StorageConstants.USED_ID);
  await localStorage.removeItem(StorageConstants.LOGIN_TIME);
};
